
import { defineComponent } from "vue";

import CustomRouterLink from "@/components/CustomRouterLink.vue";
export default defineComponent({
  name: "mobile-element",
  components: {
    CustomRouterLink,
  },
  props: {
    isMenuOpen: {
      required: true,
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const handleMenuItemClick = () => {
      emit("closeMenu");
    };
    return { handleMenuItemClick };
  },
});
